import { SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { NotFoundPage } from '@presentation/pages';

export const NotFoundPageController = () => {
  const { navigateToRoute, translate } = useRouter();

  return (
    <>
      <SeoController title={translate('notFound.seo.title')} noIndex />
      <NotFoundPage onBackClick={() => navigateToRoute('homeLanding')} />
    </>
  );
};
